/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Crowd Strike Config
 */
export interface CrowdStrikeConfig { 
    /**
     * List of supported email domains for crowdstrike user registration.
     */
    allowedDomains?: Array<string>;
    /**
     * API client location
     */
    apiClientLocation?: string;
    /**
     * API client timestamp
     */
    apiClientTimestamp?: string;
    /**
     * API endpoint
     */
    apiEndpoint?: string;
    /**
     * Crowdstrike Org Id
     */
    cid?: string;
    /**
     * if byol and/or managed capability is enabled
     */
    enablementConfig?: string;
    /**
     * Registered or Unregistered
     */
    registered?: boolean;
    /**
     * The The ARN or GCP storage URI of the Salt Master OVA file (that has scripts for sensor installation).
     */
    saltMasterOva?: string;
    vlcrManaged?: boolean;
    /**
     * Set to false when config is being removed
     */
    enabled?: boolean;
}

